export default __webpack_public_path__ + "static/media/in-new.a0b0f527.svg";